export default __webpack_public_path__ + "static/media/Badge_DownloadAPK.d4006194.svg";